import { useState } from 'react';
import { ClientPhotoUpload } from "../inputs/ClientPhotoUpload";
import { SharedFilePreview } from "./SharedFilePreview";
export const PhotoPreview = props => {
  const {
    guid,
    value,
    length = 0,
    ...restProps
  } = props;
  const isMultiple = length !== null && length > 0;
  const limit = length === null || length < 0 ? 0 : length;
  const [hasTempFiles, setHasTempFiles] = useState(false);
  const modalClassName = `portal-modal is-photo-upload ${isMultiple && hasTempFiles ? 'is-multiple-photo' : 'is-single-photo'}`;
  const renderCapturedText = value => {
    const hasMultiple = value && value.length > 1;
    const s = hasMultiple || isMultiple && !value ? 's' : '';
    return isMultiple && value.length > 0 ? `${value.length} Photo${s} Captured` : `Photo${s} Captured`;
  };
  return <SharedFilePreview guid={guid} value={value} fileType={`Photo${isMultiple ? 's' : ''}`} renderCapturedText={renderCapturedText} modalClassName={modalClassName} UploadComponent={ClientPhotoUpload} uploadProps={{
    savedImageUrl: value,
    isMultiple,
    limit: isMultiple ? limit : limit + 1,
    setHasTempFiles
  }} {...restProps} />;
};